module.exports = __webpack_public_path__ + "static/sentiment_analysis-fe28e8ce702f33fe5cde1117452ecbf8.png";